const lincoln = {
  state: () => ({
    images: {
      sedans: [
        {
          modelName: "MKZ",
          sideView: require("../../../static/images/carcuts/lincoln/side-view/mkz20.png"),
          angleView: require("../../../static/images/carcuts/lincoln/angle-view/mkz.png"),
          trims: ["Premier", "Select", "Reserve"]
        },
      ],
      suvs: [
        {
          modelName: "Aviator",
          sideView: require("../../../static/images/carcuts/lincoln/side-view/aviator22.png"),
          angleView: require("../../../static/images/carcuts/lincoln/angle-view/aviatorgt-22.png"),
          trims: ["Standard", "Reserve", "Grand Touring", "Black Label", "Black Label Grand Touring"]
        },
        {
          modelName: "Corsair",
          sideView: require("../../../static/images/carcuts/lincoln/side-view/corsair21.png"),
          angleView: require("../../../static/images/carcuts/lincoln/angle-view/corsair-19.png"),
          trims: ["Standard", "Reserve", "Grand Touring"]
        },
        {
          modelName: "Nautilus",
          sideView: require("../../../static/images/carcuts/lincoln/side-view/nautilus21.png"),
          angleView: require("../../../static/images/carcuts/lincoln/angle-view/nautilus-19.png"),
          trims: ["Standard", "Reserve", "Black Label"]
        },
        {
          modelName: "Navigator",
          sideView: require("../../../static/images/carcuts/lincoln/side-view/navigator21.png"),
          angleView: require("../../../static/images/carcuts/lincoln/angle-view/navigator.png"),
          trims: ["Standard", "Reserve", "Select", "Black Label"]
        },
      ],
      trucks: [],
      lifestyleImages: {
        defaultImage: require("../../../static/images/carcuts/lincoln/lifestyle/mkz.jpg"),
        sedanImage: require("../../../static/images/carcuts/lincoln/lifestyle/continental-19.jpg"),
        suvImage: require("../../../static/images/carcuts/lincoln/lifestyle/aviator-22.jpg"),
        truckImage: require("../../../static/images/carcuts/lincoln/lifestyle/navigator-20.jpg")
      },
      videoLink: [
        "https://player.vimeo.com/external/243867558.hd.mp4?s=e670fb1e8c00237d1f1c75b9603d1e68922b33ac&profile_id=175"
      ],
      roundButtons: [
        require("../../../static/images/buttons/round-buttons/lincoln-New.png"), require("../../../static/images/buttons/round-buttons/lincoln-Used.png"), require("../../../static/images/buttons/round-buttons/lincoln-ScheduleService.png"), require("../../../static/images/buttons/round-buttons/lincoln-Worth.png")
      ],
      browseButtons: [
        require("../../../static/images/buttons/browse-buttons/black-new.png"), require("../../../static/images/buttons/browse-buttons/black-used.png"), require("../../../static/images/buttons/browse-buttons/black-service.png"), require("../../../static/images/buttons/browse-buttons/black-specials.png")
      ],
      swoopIcons: [
        require("../../../static/images/buttons/swoop-icons/black01.png"), require("../../../static/images/buttons/swoop-icons/black03.png"), require("../../../static/images/buttons/swoop-icons/black02.png")
      ],
      homeBanners: [
        require("../../../static/images/banners/lincoln/CM-SL-CA-Lincoln-Established.jpg"), require("../../../static/images/banners/lincoln/CM-SL-CA-Lincoln-Lifestyle.jpg"), require("../../../static/images/banners/lincoln/CM-SL-CA-Lincoln-Modern.jpg"), require("../../../static/images/banners/lincoln/CM-SL-CA-Lincoln-Playful.jpg")
      ],
      stripBanners: [
        require("../../../static/images/banners/lincoln/SOKAL-SRS-121021-Aviator-Established.jpeg"), require("../../../static/images/banners/lincoln/SOKAL-SRS-121021-Aviator-Lifestyle.jpeg"), require("../../../static/images/banners/lincoln/SOKAL-SRS-121021-Aviator-Modern.jpeg"), require("../../../static/images/banners/lincoln/SOKAL-SRS-121021-Aviator-Playful-V1.jpeg")
      ],
      logoExample: [
        require("../../../static/images/buttons/logos/dd-logo-lincoln.png"),
        require("../../../static/images/buttons/logos/dd-logo-lincoln-w.png")
      ]
    },
   colors: {
      "--primary-color": "#5b6770",
      "--primary-dark": "#000",
      "--primary-light": "#FFF",
      "--secondary-color": "#51284f",
      "--secondary-dark": "#53565a",
      "--secondary-light": "#f3f3f3",
    },
    fonts: {
      "--heading-text": "LincolnMillerBanner-SemiBold, 'Georgia', Arial, sans-serif",
      "--subheading-text": "LincolnProximaNova-Bold, Arial, sans-serif",
      "--body-text": "LincolnProximaNova-Regular, Arial, sans-serif",
      "--bold-text": "LincolnProximaNova-Bold, Arial, sans-serif"
    }
  })
}


export default lincoln